module.exports = __webpack_public_path__ + "img/icon-minus.ebd26cb0.svg";